<div class="w-100">
  <div class="w-100">
    <h3 class="text-center title">{{title}}</h3>
  </div>
  <div class="w-100">
    <table class="w-100">
      <tr>
        <th style="width: 40%;">Clickable Icon</th>
        <th style="width: 60%;">Description</th>
      </tr>
      <tr>
        <td>
          <span class="material-icons icon blue-color">
            trending_up
          </span>
        </td>
        <td>Trend Chart</td>
      </tr>
      <tr>
        <td>
          <span class="material-icons icon red-color">
            trending_up
          </span>
        </td>
        <td>
          Trend Chart trending negatively
        </td>
      </tr>
      <tr>
        <td>
          <span class="border-details">Show Details</span>
        </td>
        <td>
          Expanded metrics for KPI (replaces columns in scorecard)
        </td>
      </tr>
      <tr>
        <td>
          <span class="border-details">Hide Details</span>
        </td>
        <td>
          Collapses metrics for KPI (returns scorecard to original view)
        </td>
      </tr>
      <tr>
        <td>
          <span class="material-icons icon">
            arrow_upward
            </span>
        </td>
        <td>
          Sort column in descending order
        </td>
      </tr>
      <tr>
        <td>
          <span class="material-icons icon">
            arrow_downward
            </span>
        </td>
        <td>
          Sort column in ascending order
        </td>
      </tr>
    </table>
  </div>
</div>